import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Button from 'chameleon/ui-stack/ui/base/button';

import './InlineConfirmation.scss';

class InlineConfirmation extends PureComponent {
  static propTypes = {
    handleClose: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    header: PropTypes.string.isRequired,
    footer: PropTypes.string.isRequired,
    users: PropTypes.array,
    noLabel: PropTypes.string,
    yesLabel: PropTypes.string,
    renderControlledPortion: PropTypes.func,
  };

  static defaultProps = {
    users: [],
    noLabel: 'No',
    yesLabel: 'Yes',
    renderControlledPortion: () => {},
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const {
      handleClose,
      handleSubmit,
      header,
      footer,
      users,
      renderControlledPortion,
      yesLabel,
      noLabel,
    } = this.props;

    return (
      <div className="InlineConfirmation">
        <div className="Confirmation">
          <div className="Confirmation--header">{header}</div>
          <div className="Confirmation--body">
            <Fragment>
              <div className="Confirmation--body-footer">{footer}</div>
              {renderControlledPortion()}
              <div className="Confirmation--body-users">{users.join('\n')}</div>
              <div className="Confirmation--body-warning">
                {!users.length &&
                  'Please close the modal and select at least one user in order to proceed with this action.'}
              </div>
              <div className="Confirmation--footer gap-3">
                <Button isOutline onClick={handleClose}>
                  {noLabel}
                </Button>
                <Button
                  isPrimary
                  onClick={handleSubmit}
                  disabled={!users.length}
                >
                  {yesLabel}
                </Button>
              </div>
            </Fragment>
          </div>
        </div>
      </div>
    );
  }
}

export default InlineConfirmation;
